import { useQuery } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { api } from '../../../../lib/apiClient';

const EMAIL_QUERY_KEY = 'email';

export const useSenderEmail = (emailId: ID | null) => {
  const { data } = useQuery({
    queryKey: [EMAIL_QUERY_KEY, emailId],
    queryFn: () => api.request(endpoints.email.get(emailId ?? 0)),
    enabled: !!emailId,
  });

  const { email } = data?.from || {};

  return email;
};
